import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { CodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component";
import { LargeClassCodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component";
import { MiddleClassCodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component";
import { SmallClassCodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component";
import { TextAreaComponent } from "src/app/commons/kymw02/text-input/text-area/text-area.component";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { GetClassBuyerIdService } from "../../kymw6900/api-services/get-class-buyer-id";
import { GetNewGoodsProposalService } from "./api-services/get-new-goods-proposal.service";
import { GetMasterInputService } from "./api-services/get-master-input.service";
import { RegistMasterInputService } from "./api-services/regist-master-input.service";
import { UpdateMasterInputService } from "./api-services/update-master-input.service";
import { CheckNgWordsService } from 'src/app/commons/kymw02/check-ng-words/api-services/check-ng-words.service';
import { KYMW6901MasterInputTabModel } from "./kymw6901-master-input-tab.model";
import { CodeCheckBoxListComponent } from "src/app/commons/kymw02/list/code-check-box-list/code-check-box-list.component";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { WjAccordion } from '@grapecity/wijmo.angular2.nav';
import { Router } from "@angular/router";
import { MasterInputModel } from "./vo/master-input.model";
import { KYMW6901Model, KYMW6901Tab } from "../kymw6901.model";

@Component({
  selector: 'app-kymw6901-master-input-tab',
  templateUrl: 'kymw6901-master-input-tab.component.html',
  styleUrls: ['kymw6901-master-input-tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: GetNewGoodsProposalService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetNewGoodsProposalService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub, GetClassBuyerIdService]
    },
  ]
})
export class KYMW6901MasterInputTabComponent extends PlessViewHelperSub implements OnInit, AfterViewInit {
  @Input() mode: KYMW6901Tab;
  @Input() proposalId: string;
  @Input() proposalStatus: string;
  @Input() masterInputId: string;
  @Input() pCode: string;
  @Input() itemCode: string;
  @Input() classCode: string;
  @Input() searchParams: any;

  @ViewChild('cmb_LargeClassCode', { static: true }) cmb_LargeClassCode: LargeClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode', { static: true }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCode', { static: true }) cmb_SmallClassCode: SmallClassCodeComboBoxComponent;
  @ViewChild('txti_RelationPCodeOld', { static: true }) txti_RelationPCodeOld: ElementRef;
  @ViewChild('cmb_SpecialOrderType', { static: true }) cmb_SpecialOrderType: CodeComboBoxComponent;
  @ViewChild('cmb_StockType', { static: true }) cmb_StockType: CodeComboBoxComponent;
  @ViewChild('txti_PdPilingUpDays', { static: true }) txti_PdPilingUpDays: ElementRef;
  @ViewChild('txti_FactoryAddress1', { static: true }) txti_FactoryAddress1: TextAreaComponent;
  @ViewChild('txti_FactoryAddress2', { static: true }) txti_FactoryAddress2: TextAreaComponent;
  @ViewChild('txti_FcmcFee', { static: true }) txti_FcmcFee: ElementRef;
  @ViewChild('cmb_MarkDiv1', { static: true }) cmb_MarkDiv1: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv2', { static: true }) cmb_MarkDiv2: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv3', { static: true }) cmb_MarkDiv3: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv4', { static: true }) cmb_MarkDiv4: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv5', { static: true }) cmb_MarkDiv5: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv6', { static: true }) cmb_MarkDiv6: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv7', { static: true }) cmb_MarkDiv7: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv8', { static: true }) cmb_MarkDiv8: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv9', { static: true }) cmb_MarkDiv9: CodeComboBoxComponent;
  @ViewChild('cmb_MarkDiv10', { static: true }) cmb_MarkDiv10: CodeComboBoxComponent;
  @ViewChild('lst_EcologyDiv', { static: true }) lst_EcologyDiv: CodeCheckBoxListComponent;
  @ViewChild('cmb_PriceType', { static: true }) cmb_PriceType: CodeComboBoxComponent;

  private readonly PROPOSAL_BEFORE = '0';
  model = new KYMW6901MasterInputTabModel();
  // ユーザ権限
  public isFullControl = this.getFuncPermission('KYMW6900') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

  // 商品基本マスタ承認状態が本登録（"2"）のときtrue
  public hontouroku = false;
  private readonly STATUS_HONTOROKU = "2";

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    protected kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getMasterInputService: GetMasterInputService,
    private getNewGoodsProposalService: GetNewGoodsProposalService,
    private updateMasterInputService: UpdateMasterInputService,
    private registMasterInputService: RegistMasterInputService,
    private checkNgWordsService: CheckNgWordsService,
  ) {
    super(kymw00Model);

    // 原因不明で this.router が undefined になってしまうので model に退避しておく
    this.model.router = this.router;

    const coopMap = {
      [kymw00Model.COOP_CODE_IB]: 'ibaraki',
      [kymw00Model.COOP_CODE_TO]: 'tochigi',
      [kymw00Model.COOP_CODE_GU]: 'gunma',
      [kymw00Model.COOP_CODE_TI]: 'chiba',
      [kymw00Model.COOP_CODE_SA]: 'saitama',
      [kymw00Model.COOP_CODE_TK]: 'tokyo',
      [kymw00Model.COOP_CODE_NA]: 'nagano',
      [kymw00Model.COOP_CODE_NI]: 'niigata'
    };
    this.model.setCoopMap(coopMap);

    this.model.loginUser = {
      userId: this.kymw00Model.kymw1001Model.loginUserInfo.UserID,
      associatedUserType: this.kymw00Model.kymw1001Model.loginUserInfo.AssociatedUserType,
      userClassList: this.kymw00Model.kymw1001Model.loginUserInfo.UserClassList.map(_ => {
        return {
          classCode: _.ClassCode,
          userClass: _.UserClass
        }
      })
    };
  }

  ngOnInit() {
    this.componentName = 'KYMW6901MasterInputTab';
    this.model.masterInput.pCode = this.pCode;
    this.model.masterInput.itemCode = this.itemCode;
    this.model.masterInput.classCode = this.classCode;
    this.model.masterInput.proposalId = this.proposalId;
    this.model.masterInput.masterInputId = this.masterInputId;
    this.model.searchParams = this.searchParams;
    if (this.proposalId) {
      if (this.masterInputId) {
        this.getMasterInputService.execute(this.model, this.masterInputId, this.proposalId, () => {
          this.initMarkDiv();
          // 商品基本マスタ承認状態が２（本登録）の場合、全項目非活性、登録ボタン・日付クリアボタン非表示
          this.hontouroku = this.model.masterInput.goodsBaseAdmitStatus == this.STATUS_HONTOROKU;
          setTimeout(() => {
            this.initClassCodeCmbs();
            this.initEcologyDiv();
          });
          if (this.model.masterInput.classCode === '07') {
            this.model.selectedTabIndex = 1;
          }
        }
        );
        return;
      } else {
        this.getNewGoodsProposalService.execute(this.proposalId, this.model, (newGoodsProposal) => {
          const masterInput = MasterInputModel.fromNewGoodsProposal(newGoodsProposal, this.pCode, this.itemCode);
          this.model.masterInput = masterInput;
          if (this.model.masterInput.classCode === '07') {
            this.model.selectedTabIndex = 1;
          }
          this.initMarkDiv();
          this.initPriceType();
        });
      }
    }
  }

  /** 
   * 既存商品コピー後　表示設定
   */
  public setInit_AfterCopy() {
    this.initClassCodeCmbs();
    this.initEcologyDiv();
  }

  private initClassCodeCmbs() {
    if (this.model.masterInput.largeClassCode) {
      this.cmb_LargeClassCode.setLargeClassCode(this.model.masterInput.largeClassCode);
      if (this.model.masterInput.middleClassCode) {
        this.cmb_MiddleClassCode.setMiddleClassCode(this.model.masterInput.middleClassCode);
        if (this.model.masterInput.smallClassCode) {
          this.cmb_SmallClassCode.setSmallClassCode(this.model.masterInput.smallClassCode);
        }
      }
    }
  }

  public initMarkDiv() {
    // ReserveNum1が部門に依存しており、部門を取得した後にマークを取得するためこのタイミングでctpの値を設定
    this.model.markDivCtp = 'ctp321';

    this.cmb_MarkDiv1.setCodeValue(this.model.masterInput.markDiv.markDiv1);
    this.cmb_MarkDiv2.setCodeValue(this.model.masterInput.markDiv.markDiv2);
    this.cmb_MarkDiv3.setCodeValue(this.model.masterInput.markDiv.markDiv3);
    this.cmb_MarkDiv4.setCodeValue(this.model.masterInput.markDiv.markDiv4);
    this.cmb_MarkDiv5.setCodeValue(this.model.masterInput.markDiv.markDiv5);
    this.cmb_MarkDiv6.setCodeValue(this.model.masterInput.markDiv.markDiv6);
    this.cmb_MarkDiv7.setCodeValue(this.model.masterInput.markDiv.markDiv7);
    this.cmb_MarkDiv8.setCodeValue(this.model.masterInput.markDiv.markDiv8);
    this.cmb_MarkDiv9.setCodeValue(this.model.masterInput.markDiv.markDiv9);
    this.cmb_MarkDiv10.setCodeValue(this.model.masterInput.markDiv.markDiv10);
  }

  private initPriceType() {
    this.cmb_PriceType.setCodeValue(this.model.masterInput.priceType);
  }

  private initEcologyDiv() {
    // 一度全てOFFにする
    this.lst_EcologyDiv.updateCheckCodeValue(null, false);
    for(const val of this.model.masterInput.ecologyDivList) {
      if (val) {
        this.lst_EcologyDiv.updateCheckCodeValue(val, true);
      }
    }
  }


  ngAfterViewInit() {
    if (this.model.isClient()) {
      this.setBuyerInputDisable();
    }
    this.setChangeEvent();
  }

  private setBuyerInputDisable() {
    this.plessEnabled(this.txti_RelationPCodeOld, false);
    this.plessEnabled(this.cmb_SpecialOrderType, false);
    this.plessEnabled(this.cmb_StockType, false);
    this.plessEnabled(this.txti_PdPilingUpDays, false);
    this.plessEnabled(this.txti_FactoryAddress1, false);
    this.plessEnabled(this.txti_FactoryAddress2, false);
    this.plessEnabled(this.txti_FcmcFee, false);
  }

  private setChangeEvent() {
    const filedIds = [
      'txti_Jancode',
      'txti_goodsName',
      'txti_standardName',
      'cmb_MediumType',
      'cmb_ClassCode',
      'cmb_LargeClassCode',
      'cmb_MiddleClassCode',
      'cmb_SmallClassCode',
      'cmb_OrderUnitType',
      'txti_SetQuantity',
      'txti_standardSellingPrice',
      'txti_special1SellingPrice',
      'txti_special2SellingPrice',
      'txti_standardCostPrice',
      'txti_special1CostPrice',
      'txti_special2CostPrice',
      'txti_BundlePrice',
      'cmb_UnitPriceDiv',
      'cmb_EdlpDiv',
      'txti_UnitPriceCoefficient',
      'txti_expirationDate',
      'txti_UnitPriceUnit',
      'txti_bestBeforeDate',
      'cmb_SetDiv',
      'cmb_ArrivalAreaDiv',
      'cmb_BrandType',
      'cmb_CycleTerm',
      'cmb_CaseSupplyDiv',
      'txti_ArrivalGoodsTemp',
      'txti_ArrivalAdminDays',
      'lst_EcologyDiv',
      'cmb_PriceType',
      'txti_MarkerPrice',
      'chk_allCoop',
      'chk_ibaraki',
      'chk_tochigi',
      'chk_gunma',
      'chk_chiba',
      'chk_saitama',
      'chk_tokyo',
      'chk_nagano',
      'chk_niigata',
      'txti_PackagePhotoNum',
      'txti_PackageDataNum',
      'txti_PeakPhotoNum',
      'txti_PeakDataNum',
      'txti_CookingNecessaryPhotoNum',
      'txti_CookingNecessaryDataNum',
      'txti_CookingUnnecessaryPhotoNum',
      'txti_CookingUnnecessaryDataNum',
      'txti_MaterialPhotoNum',
      'txti_MaterialDataNum',
      'txti_BacksidePhotoNum',
      'txti_BacksideDataNum',
      'txb_GoodsExplanation',
      'txb_RecommendComment',
      'txb_UsefulInfoConfiguration',
      'txb_UsefulInfoSize',
      'txb_CatchPhrase',
      'txb_UsefulInfoEnclosure',
      'txb_UsefulInfoOther',
      'txb_HandlingCaution',
      'cmb_MarkDiv1',
      'cmb_MarkDiv2',
      'cmb_MarkDiv3',
      'cmb_MarkDiv4',
      'cmb_MarkDiv5',
      'cmb_MarkDiv6',
      'cmb_MarkDiv7',
      'cmb_MarkDiv8',
      'cmb_MarkDiv9',
      'cmb_MarkDiv10',
      'txti_consumeTaxRate',
      'txti_alcoholPercentage',
      'txti_sakeMeterValue',
      'cmb_functionalOrFoshu',
      'txti_fruitJuice',
      'txti_body',
      'cmb_LiquorCode',
      'txti_AlcoholType',
      'cmb_ContainerForm',
      'dtf_ApplyTermStart',
      'dtf_ApplyTermEnd',
      'chk_SeasonConsumeDiv',
      'dtf_SeasonConsumeTermStart',
      'dtf_SeasonConsumeTermEnd',
      'cmb_StinkGoodsDiv',
      'txti_listingGoodsName',
      'txti_ListingType',
      'txti_ListingSizeCm',
      'txti_PieceSizeLength',
      'txti_PieceSizeWidth',
      'txti_PieceSizeHeight',
      'txti_PieceWeight',
      'txti_ListingContentsQuantity',
      'txti_ListingNumber',
      'txti_CaseSizeLength',
      'txti_CaseSizeWidth',
      'txti_CaseSizeHeight',
      'txti_CaseWeight',
      'txti_ListingSize',
      'txti_ListingColor',
      'txb_IngredientInfo',
      'txb_IngredientDisp',
      'txti_RelationPCodeOld',
      'cmb_SpecialOrderType',
      'cmb_StockType',
      'txti_PdPilingUpDays',
      'txti_FactoryAddress1',
      'txti_FactoryAddress2',
      'txti_FcmcFee',
    ];
    filedIds.forEach(fieldId => {
      document.getElementById(fieldId).addEventListener('change', () => {
        this.model.hasChanged = true;
      });
    });

  }

  eventAllCoop_CHANGEHandler() {
    const coops = Object.keys(this.model.masterInput.expandableCoop);
    this.model.masterInput.expandableCoop = coops.reduce(
      (prev, coop) => ({ ...prev, [coop]: this.model.masterInput.allCoop }),
      this.model.masterInput.expandableCoop);
  }
  eventCoop_CHANGEHandler() {
    const isAllChecked = Object.values(this.model.masterInput.expandableCoop).every(coopChecked => coopChecked);
    this.model.masterInput.allCoop = isAllChecked;
  }

  isBeforeProposing() {
    return this.proposalStatus === '' || this.proposalStatus === this.PROPOSAL_BEFORE;
  }

  eventRegist_CLICKHandler() {
    this.getSelectedCodeValue();

    const error = this.model.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return;
    }

    this.dialogService.openAlertGetMessage('Q0188', [], (closeDetail: PlessAlert) => {
      if (closeDetail === PlessAlert.Yes) {
        if (this.model.masterInput.masterInputId) {
          this.updateMasterInputService.execute(this.model, this.openCompletionModal);
        } else {
          this.registMasterInputService.execute(this.model, this.openCompletionModal);
        }
      }
    });
  }

  private getSelectedCodeValue() {
    this.model.masterInput.largeClassCode = this.cmb_LargeClassCode.selectedLargeClassCode;
    this.model.masterInput.middleClassCode = this.cmb_MiddleClassCode.selectedMiddleClassCode;
    this.model.masterInput.smallClassCode = this.cmb_SmallClassCode.selectedSmallClassCode;
    this.model.masterInput.ecologyDivList = this.lst_EcologyDiv.codeList.reduce((prev, code) => {
      if (code.selectedValue) {
        return [...prev, code.CodeValue];
      } else {
        return prev;
      }
    }, []);
  }

  private openCompletionModal() {
    this.dialogService.openAlertGetMessage('I0106', ['登録が完了'], (() => {
      this.model.router.navigate(['/kymw/6900'], {
        queryParams: {
          searchProposalStatus: this.model.searchParams.searchProposalStatus,
          searchClassCode: this.model.searchParams.searchClassCode,
          searchProposalUserId: this.model.searchParams.searchProposalUserId,
          searchBuyerId: this.model.searchParams.searchBuyerId,
          searchGoodsAndStandardName: this.model.searchParams.searchGoodsAndStandardName,
          searchStartOrderCode: this.model.searchParams.searchStartOrderCode,
          searchDelivCatalogId: this.model.searchParams.searchDelivCatalogId,
          searchPCode: this.model.searchParams.searchPCode,
          searchMasterInputStatus: this.model.searchParams.searchMasterInputStatus
        }
      });
    }));
  }

  updateMasterInputOnProposal(onSuccess: () => void) {
    this.getSelectedCodeValue();
    this.updateMasterInputService.execute(this.model, onSuccess)
  }

  registerMasterInputOnProposal(proposalId: string, classCode: string, onSuccess: () => void) {
    this.getSelectedCodeValue();
    this.model.masterInput.proposalId = proposalId;
    this.model.masterInput.classCode = classCode;
    // マスタ入力表に入力がない場合、提案タブの提案ボタン押下時にマスタ入力表を登録しない
    if (!this.model.existsMasterInputValue()) {
      if (onSuccess) {
        onSuccess();
      }
      return;
    }

    this.registMasterInputService.execute(this.model, onSuccess);
  }

  hasChanged() {
    return this.model.hasChanged;
  }

  public initCollapsed(wad: WjAccordion, collapsed = true) {
    wad.panes.forEach(_ => (_.isCollapsed = collapsed));
  }

  public eventTextInfo1_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.goodsExplanation)) {
      const vo = {
        itemName: '商品説明',
        string: this.model.masterInput.goodsExplanation,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo2_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.catchPhrase)) {
      const vo = {
        itemName: 'キャッチコピー',
        string: this.model.masterInput.catchPhrase,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo3_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.recommendComment)) {
      const vo = {
        itemName: 'おすすめコメント',
        string: this.model.masterInput.recommendComment,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo4_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.usefulInfoEnclosure)) {
      const vo = {
        itemName: '便利情報(囲み)',
        string: this.model.masterInput.usefulInfoEnclosure,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo5_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.usefulInfoConfiguration)) {
      const vo = {
        itemName: '便利情報(商品構成内容)',
        string: this.model.masterInput.usefulInfoConfiguration,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo6_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.usefulInfoOther)) {
      const vo = {
        itemName: '便利情報(その他)',
        string: this.model.masterInput.usefulInfoOther,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo7_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.usefulInfoSize)) {
      const vo = {
        itemName: '便利情報（サイズ他）',
        string: this.model.masterInput.usefulInfoSize,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo8_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.handlingCaution)) {
      const vo = {
        itemName: '取扱注意',
        string: this.model.masterInput.handlingCaution,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfo9_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.ingredientInfo)) {
      const vo = {
        itemName: '成分情報（化粧品）',
        string: this.model.masterInput.ingredientInfo,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  public eventTextInfoA_FOCUS_OUTHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.model.masterInput.ingredientDisp)) {
      const vo = {
        itemName: '原材料表示（ペットのみ）',
        string: this.model.masterInput.ingredientDisp,
      };
      this.checkNgWordsService.execute(null, vo);
    }
  }

  isRegistOrBeforeProposing(): boolean {
    return this.mode === KYMW6901Model.DISPLAY_MODE_REGIST || this.isBeforeProposing();
  }

  public eventApplyTermClearHandler() {
    this.model.masterInput.applyTermStart = '';
    this.model.masterInput.applyTermEnd = '';
  }

  public eventSeasonConsumeTermClearHandler() {
    this.model.masterInput.seasonConsumeTermStart = '';
    this.model.masterInput.seasonConsumeTermEnd = '';
  }

  eventJanCode_FOCUS_OUTHandler() {
    this.model.parent.ProposalTab.model.newGoodsProposal.janCode = this.model.masterInput.janCode;
  }
}
